import React, { useContext, useRef, useState, useEffect } from "react";
import "../../css_files/Ticket/TicketTable.css";
import Swal from "sweetalert2";
import axios from "axios";
import getCookie from "../../api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api";
import { triggerscroll } from "../Homepage/Homepage";

function TicketTable({
  ticketsData,
  setshowticketpopup,
  setTicketId,
  refresh,
  setrefresh,
  setEnquiryId,
  setshowticketdetail,
  setshowticketinfo,
  setticketinfodata,
  loading,
  setShowAssignedUsers,
  setShowAssignedUsersEdit,
  readPermission,
  updatePermission,
  deletePermission,
}) {
  const nav = useNavigate();
  const tableRef = useRef();
  const { userData } = useContext(triggerscroll);
  const [deleteLoader, setDeleteLoader] = useState([]);

  useEffect(() => {
    setDeleteLoader(Array.from({ length: ticketsData?.length }, () => false));
  }, [ticketsData?.length]);

  return (
    <>
      <blockquote
        className="navigate-left-right-bottom-table"
        style={{ marginBottom: "3px" }}
      >
        <button
          onClick={() => {
            tableRef.current.scrollBy({
              left: -tableRef.current.scrollWidth,
              behavior: "smooth",
            });
          }}
        >
          <i className="fa-solid fa-arrow-left"></i>
        </button>

        <button
          onClick={() => {
            tableRef.current.scrollBy({
              left: tableRef.current.scrollWidth,
              behavior: "smooth",
            });
          }}
        >
          <i className="fa-solid fa-arrow-right"></i>
        </button>
      </blockquote>

      <section className="table" ref={tableRef}>
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(11, 1fr)" }}>
              <blockquote style={{ width: "15rem" }}>Ticket ID</blockquote>
              <blockquote style={{ width: "15rem" }}>
                Company/Organization Name
              </blockquote>

              <blockquote style={{ width: "15rem" }}>Due Date</blockquote>
              <blockquote style={{ width: "15rem" }}>Status</blockquote>
              <blockquote style={{ width: "15rem" }}>Assigned Users</blockquote>
              <blockquote style={{ width: "15rem" }}>Quotation Sent</blockquote>
              <blockquote style={{ width: "15rem" }}>Order Created</blockquote>

              <blockquote style={{ gridColumn: "span 3", width: "15rem" }}>
                Actions
              </blockquote>
            </aside>
          </div>
          <div>
            {readPermission() ? (
              loading ? (
                <aside style={{ gridTemplateColumns: "repeat(11, 1fr)" }}>
                  <blockquote style={{ gridColumn: "span 11" }}>
                    <center>
                      <i
                        class="fa-solid fa-snowflake fa-spin"
                        style={{ fontSize: "2.5rem" }}
                      ></i>
                    </center>
                  </blockquote>
                </aside>
              ) : ticketsData?.length > 0 ? (
                ticketsData.map((ticket, index) => (
                  <aside style={{ gridTemplateColumns: "repeat(11, 1fr)" }}>
                    <blockquote style={{ width: "15rem" }}>
                      {ticket.seriesId}
                    </blockquote>
                    <blockquote style={{ width: "15rem" }}>
                      {ticket.customer.orgName}
                    </blockquote>

                    <blockquote style={{ width: "15rem" }}>
                      {new Date(ticket.serviceDetails.dueDate).toDateString()}
                    </blockquote>
                    <blockquote style={{ width: "15rem" }}>
                      {ticket.status}
                    </blockquote>
                    <blockquote style={{ width: "15rem" }}>
                      <a
                        href="#"
                        onClick={() => {
                          setShowAssignedUsers(true);
                          setTicketId(ticket.seriesId);
                          setShowAssignedUsersEdit(
                            userData?.role === "Administrator" &&
                              ticket.isOrderCreated
                          );
                        }}
                      >
                        Tap Here to See More Details
                      </a>
                    </blockquote>
                    <blockquote style={{ width: "15rem" }}>
                      {ticket.isQuotationSent
                        ? "Yes"
                        : ticket.serviceDetails.serviceType === "FOC"
                        ? "Not Applicable"
                        : "No"}
                    </blockquote>
                    <blockquote style={{ width: "15rem" }}>
                      {ticket.isOrderCreated
                        ? "Yes"
                        : ticket.serviceDetails.serviceType === "FOC"
                        ? "Not Applicable"
                        : "No"}
                    </blockquote>

                    <blockquote
                      onClick={() => {
                        if (ticket.isOrderCreated) {
                          setTicketId(ticket.seriesId);
                          setshowticketdetail(true);
                        } else if (
                          ticket.serviceDetails.serviceType === "FOC" ||
                          ticket.isQuotationSent
                        ) {
                          setshowticketinfo(true);
                          setticketinfodata(ticket);
                        } else {
                          setTicketId(ticket.seriesId);
                          setEnquiryId(ticket.enquirySeriesId);
                          nav("/dashboard/checkin/steps/step2");
                        }
                      }}
                      style={{ width: "5rem" }}
                    >
                      <i className="fa-solid fa-eye"></i>
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        setTicketId(ticket.seriesId);
                        setshowticketpopup(true);
                      }}
                      style={{
                        pointerEvents: updatePermission() && "none",
                        width: "5rem",
                      }}
                    >
                      <i
                        className="fa-solid fa-pen-to-square"
                        style={{
                          color: updatePermission() && "gray",
                        }}
                      ></i>
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        Swal.fire({
                          title: "Are you sure?",
                          text: "You won't be able to revert this!",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes, delete it!",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            setDeleteLoader((prev) =>
                              prev.map((_, i) => i === index)
                            );
                            axiosInstance
                              .put(
                                `${process.env.REACT_APP_API_URL}/api/v1/Ticket`,
                                {
                                  SeriesId: ticket?.seriesId,
                                  isDeleted: true,
                                }
                              )
                              .then((res) => {
                                toast.success("Record Deleted Successfully", {
                                  position: "bottom-center",
                                  theme: "dark",
                                });
                                setrefresh(!refresh);
                              })
                              .catch(console.log)
                              .finally(() => {
                                setDeleteLoader((prev) =>
                                  prev.map((_) => false)
                                );
                              });
                          }
                        });
                      }}
                      style={{
                        pointerEvents: deletePermission() && "none",
                        width: "5rem",
                      }}
                    >
                      {deleteLoader[index] ? (
                        <i
                          class="fa-solid fa-hurricane fa-spin"
                          title="Please Wait..."
                        ></i>
                      ) : (
                        <i
                          className="fa-solid fa-trash"
                          style={{
                            color: deletePermission() && "gray",
                          }}
                        ></i>
                      )}
                    </blockquote>
                  </aside>
                ))
              ) : (
                <aside style={{ gridTemplateColumns: "repeat(11, 1fr)" }}>
                  <blockquote style={{ gridColumn: "span 11" }}>
                    <center>
                      <h3>No Tickets Created</h3>
                    </center>
                  </blockquote>
                </aside>
              )
            ) : (
              <aside style={{ gridTemplateColumns: "repeat(11, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 11" }}>
                  <center>You Do Not Have Permission To Read Data</center>
                </blockquote>
              </aside>
            )}
          </div>
        </section>
      </section>
    </>
  );
}

export default TicketTable;
